export default __webpack_public_path__ + "static/media/Resultado Final.6f3fcb84.pdf";